import React from 'react';
import { Box, Typography } from '@mui/material';

/** Get file type label from extension */
export const getFileTypeLabel = (extension: string): string => {
  const ext = extension.toLowerCase();
  switch (ext) {
    case '.pdf': return 'PDF Document';
    case '.doc':
    case '.docx': return 'Word Document';
    case '.xls':
    case '.xlsx': return 'Excel Spreadsheet';
    case '.png':
    case '.jpg':
    case '.jpeg':
    case '.gif': return 'Image File';
    case '.txt': return 'Text File';
    default: return 'Document';
  }
};

interface FileNameProps {
  fileName: string;
  extension: string;
}

/**
 * Displays file name with type label.
 */
export const FileName: React.FC<FileNameProps> = ({ fileName, extension }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 500, color: '#1e293b', fontSize: '0.875rem' }}>
        {fileName}
      </Typography>
      <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.75rem' }}>
        {getFileTypeLabel(extension)}
      </Typography>
    </Box>
  </Box>
);

/** Syncfusion grid template wrapper */
export const fileNameTemplate = (props: { fileName: string; extension: string; fileType?: string }) => (
  <FileName fileName={props.fileName} extension={props.extension} />
);

export default FileName;
